import { connect } from 'react-redux'
import { compose } from 'redux'
import { MAIN } from '../../constants/programSectionTypes'
import toJS from '../../hoc/toJS'
import SelectionDisplayContainer from './SelectionDisplayContainer'
import getData from '../../functions/getData'
import { PROGRAM_SELECTIONSDISPLAY_ITEMS, PROGRAM_SELECTIONSDISPLAY_ORDER } from '../../constants/state'

const mapStateToProps = state => ({
    displaySelectionMain:   getData(state, PROGRAM_SELECTIONSDISPLAY_ITEMS).find(selection => MAIN === selection.get('type')),
    displaySelectionsOrder: getData(state, PROGRAM_SELECTIONSDISPLAY_ORDER)
})

const DisplaySectionMainContainer = ({displaySelectionMain, displaySelectionsOrder}) => {
    const { selectionPk } =  displaySelectionMain

    return <SelectionDisplayContainer 
        id={selectionPk}
        displaySelection={displaySelectionMain}
        displaySelectionsOrder={displaySelectionsOrder}
        enableDeleteSelection={false}
    />
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(DisplaySectionMainContainer)